import React from "react";
import { Link } from "react-router-dom";
import { apiUrl } from "../../../config";
import { formatINR } from "../../../App";

const ProductCard = ({
  data,
  styles,
  inWishlist,
  inCart,
  onToggleWishlist,
  onAddToCart,
  onGoToCart,
  isFromWishlist = false,
  onRemoveFromWishlist,
  loadingItem,
}) => {
  const productId = isFromWishlist ? data.productId : data.id;
  const productWeight = isFromWishlist ? data.weight : data.weight;
  const productPrice =  Math.round(data.ornamentPrice);
  const productBeforeGst = data.priceBeforeGst;
  const productName = isFromWishlist ? data.name : data.name;
  const productOrnamentPrice =
    String(productPrice).toLowerCase() === "out of stock";
  const isStockUnavailable =
    String(data.stockAvailability).toLowerCase() === "no";
  const isInvalidPrice = !productPrice || isNaN(Number(productPrice));

  const isOutofStock =
    productOrnamentPrice || isStockUnavailable || isInvalidPrice;
  const productDiscount = isFromWishlist ? data.discount : data.discount;
  const discountPrice =Math.round(
    productDiscount > 0
      ? productPrice - (productBeforeGst * productDiscount) / 100
      : productPrice);

  const getProductImageUrl = () => {
    if (isFromWishlist) {
      return data.productImageUrl
        ? `${apiUrl}/${data.productImageUrl}`
        : "/assets/images/placeholder.png";
    } else {
      if (data.images && data.images.length > 0) {
        return `${apiUrl}/${data.images[0].imageUrl}`;
      }
      return "/assets/images/placeholder.png";
    }
  };

  const imageUrl = getProductImageUrl();

  return (
    <li
      style={styles.productItem}
      className="col-lg-3 col-md-4 col-sm-6 col-12"
    >
      <Link to={`/${productId}`} style={styles.productName}>
        <div style={styles.productInner} className="product-inner">
          <div className="product-top">
            {productDiscount > 0 && !isOutofStock && (
              <span
                style={{
                  position: "absolute",
                  left: "0px",
                  top: "0px",
                  background: "#c05c2eff",
                  color: "#fff",
                  padding: "3px 15px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  borderRadius: "8px 0px 14px 0px",
                  zIndex: 2,
                }}
              >
                {productDiscount}% Discount
              </span>
            )}
            {!isOutofStock &&(
            isFromWishlist ? (
              <button
                type="button"
                style={styles.heartBtn}
                onClick={(e) => {
                  e.preventDefault();
                  if (onRemoveFromWishlist) {
                    onRemoveFromWishlist(data.wishlistId);
                  }
                }}
                disabled={loadingItem === data.wishlistId}
                
              >
                {loadingItem === data.wishlistId ? (
                  <span style={styles.loader}></span>
                ) : (
                  <i className="ph ph-trash text-white bg-danger p-2 rounded"></i>
                )}
              </button>
            ) : (
              <button
                type="button"
                style={styles.heartBtn}
                onClick={(e) => {
                  e.preventDefault();
                  if (onToggleWishlist) {
                    onToggleWishlist(productId);
                  }
                }}
              >
                <i
                  className={`${inWishlist ? "ph ph-heart-fill" : "ph ph-heart-fill"}`}
                  style={{ color: inWishlist ? "red" : "gray" }}
                ></i>
              </button>
            ))}
          </div>

          <div style={styles.productThumb}>
            <img src={imageUrl} alt={productName} style={styles.productImg} />
          </div>

          <div style={styles.productInfo}>
            <h4 className="product-name" style={{textTransform:'capitalize'}}>{productName}</h4>
            <div className="group-info">
              <div className="stars-rating">
                <div className="star-rating">
                  <span className="star-5"></span>
                </div>
                <div className="count-star">(7)</div>
              </div>
              <p
                style={{
                  color: "#009009",
                  borderRadius: "8px",
                  padding: "2px 6px",
                  fontSize: "13px",
                  fontWeight: "bold",
                }}
              >
                {productWeight}g
              </p>

              {isOutofStock ? (
                <p
                  style={{
                    marginTop: "5px",
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "red",
                  }}
                >
                  Out of Stock
                </p>
              ) : (
                <>
                  <div
                    style={{
                      marginTop: "5px",
                      fontSize: "15px",
                      fontWeight: 600,
                      color: "black",
                    }}
                  >
                    {productDiscount > 0 ? (
                      <>
                        <p style={{ color: "black", fontWeight: "bold" }}>
                          {formatINR(discountPrice)}
                        </p>
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#888",
                            marginRight: "8px",
                            fontSize: "14px",
                          }}
                        >
                          {formatINR(productPrice)}
                        </span>
                      </>
                    ) : (
                      <span style={{ color: "black" }}>
                        {formatINR(productPrice)}

                      </span>
                    )}
                  </div>

                  <div className="mt-2">
                    <button
                      className={
                        inCart
                          ? "go-cart-btn py-1 px-3 fs-4"
                          : "add-cart-btn py-1 px-3 fs-4"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        inCart ? onGoToCart() : onAddToCart(productId);
                      }}
                    >
                      {inCart ? "Go To Cart" : "Add To Cart"}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default ProductCard;
